import axios from "axios";
import { NGROK } from "../APIs";
import { clearLocalStorageOnLogout } from "./Helpers";

export const channel = new BroadcastChannel("logout");

export const logOut = async (email) => {
  channel.postMessage({ logoutMessage: "logout" });
  try {
    // Must await so Authorization is sent before localStorage is cleared.
    await axios.get(`${NGROK}/api/logout`);
  } catch (error) {
    console.error(error);
  }
};

export const getClientId = (realm) => {
  const realmCLientId = {
    whiteswan_tenants: "otp-auth",
    whiteswan_tenants_initial: "otp-auth-initial",
    whiteswan_tenants_legacy: "otp-auth-legacy",
  };
  return realmCLientId[realm] || `otp-auth-${realm}`;
};
